<template>
  <div class="texteditor_component">
    <v-snackbar v-model="snackbar"
                top
                :color="snackbarColor"
                :timeout="timeout">
      {{snackbarText}}
      <v-btn text @click="snackbar = false">
        Close
      </v-btn>
    </v-snackbar>
    <div id="toolbar-container"></div>
    <div class="texteditor_component__header">
      <h1 class="editor-title">{{category}}</h1>
      <button @click="saveText()" id="save_txtEditor" class="btn save_btn"><i class="material-icons">save</i><span class="title">Save</span></button>
    </div>
    <div class="texteditor_component__version" v-if="versionTimestamp">
        <p>
            Version <span>{{versionTimestamp}}</span>
        </p>
    </div>
    <div class="page-wrap" name="content" id="editor" :key="componentKey">
      <editor class="texteditor_component__editor" api-key="vnzp6ok5x44c701bfmvm0oa1el7l6gkrsy9mh2d4u0t33r4q" :init="editorConfig" v-model="textEditorData"></editor>
    </div>

  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import { appActions } from '@/constants/'
import ApiService from '@/services/ApiService'
import Editor from '@tinymce/tinymce-vue'

const { mapState } = createNamespacedHelpers('applicationState')

export default {
  name: 'thetexteditor',
  components: {
    Editor
  },
  props: {
    language: String,
    category: String,
    simlifiedFormatting: Boolean
  },
  data () {
    return {
      apiService: new ApiService(),
      content: '',
      editorContent: null,
      type: '',
      lan: '',
      isDataUpdated: false,
      isTextEditorCreated: false,
      textEditorData: '',
      componentKey: 0,
      snackbarText: 'Saved successfully',
      snackbarColor: 'success',
      snackbar: false,
      timeout: 5000,
      versionTimestamp: null
    }
  },
  methods: {
    forceRerender () {
      this.componentKey += 1
    },

    saveText (evt) {
      var obj = {
        EditHtmlEditorTitle: 'new title',
        EditHtmlEditorContent: this.textEditorData
      }

      this.$store.dispatch('applicationState/' + appActions.UPDATE_TEXT_TO_API, obj)
        .then(data => {
          this.snackbarText = 'Saved successfully'
          this.snackbarColor = 'success'
          this.snackbar = true
        })
        .catch(err => {
          this.snackbarText = `Error: ${err}`
          this.snackbarColor = 'error'
          this.snackbar = true
        })

      this.loadData()
    },
    updateEditorContent (value) {
      this.textEditorData = value
      this.forceRerender()
    },
    loadData () {
      this.$store.dispatch('applicationState/' + appActions.UPDATE_URL_API, this.$route.params.app + '/' + this.$route.params.category + '/' + this.$route.params.langCode)

      this.$store.dispatch('applicationState/' + appActions.UPDATE_TEXT_FROM_API, { url: this.$route.params.app + '/' + this.$route.params.category + '/' + this.$route.params.langCode }).then((res) => {
        this.textEditorData = res.editorContent
        this.versionTimestamp = res.versionTimestamp
      })
    }
  },
  mounted () {
    this.loadData()
  },
  created () {
    this.$store.dispatch('applicationState/' + appActions.UPDATE_TEXT_FROM_API, { url: this.$route.params.app + '/' + this.$route.params.category + '/' + this.$route.params.langCode }).then((res) => {
      this.textEditorData = res.editorContent
      this.versionTimestamp = res.versionTimestamp
    })
  },
  computed: {
    ...mapState({
      editorText: state => state.editorText,
      titleContent: state => state.textFromAPI.title,
      htmlEditorContent: state => state.textFromAPI.htmlEditorContent
    }),
    editorConfig: function () {
      let configs = {
        plugins: 'link paste',
        menubar: 'file edit view format insert',
        toolbar: 'undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | outdent indent | link'
      }

      if (this.simlifiedFormatting) {
        configs.menu = {
          edit: { title: 'Edit', items: 'undo redo  | cut copy paste selectall | searchreplace' },
          view: { title: 'View', items: 'visualaid' },
          format: { title: 'Format', items: 'bold italic underline strikethrough superscript subscript codeformat | formats blockformats fontformats fontsizes align lineheight | removeformat' },
          insert: { title: 'Insert', items: 'link' }
        }
      }

      return configs
    }
  },
  watch: {
    editorText (newValue, oldValue) {
      if (newValue !== oldValue) {
        this.textEditorData = newValue
      }
    },
    language (newValue, oldValue) {
      if (newValue !== oldValue) {
        this.loadData()
      }
    }
  }
}
</script>

<style lang="scss">
@import "@/scss/main.scss";

.texteditor_component {
  max-height: 90vh;
  height: rem(670);
  width: 100%;
  text-align: left;
  border-radius: rem(4);
  background-color: rgba($light, 0.4);
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1);

  &__header{
    width: 100%;
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;

    .editor-title{
      color: $primary;
      text-align: left;
      font-weight: bold;
      padding: rem(20) rem(16) rem(12) rem(28);
    }

    .save_btn{
      color: $light;
      background-color: rgba($save, 0.8);

      .material-icons{
        color: rgba($light, 1);
      }

      &:hover{
        background-color: rgba($save, 1);
        padding: rem(10) rem(16) rem(12) rem(28);
        transition: 0.4s;

        .title{
          margin-left: rem(4);
          transition: 0.4s;
        }

        .material-icons{
          color: rgba($save, 1);

          &:before{
            border-radius: rem(10) 0 0 rem(10);
            width: rem(50);
            opacity: 1;
            transition: 0.4s;
          }
          &:after{
            opacity: 1;
            left: rem(31);
            transition: 0.3s;
            transition-delay: 0.2s;
            transition-property: all;
          }
        }
      }

      &:active {
        transform: translateY(4px);
        transition: 0.2s;
      }
    }
  }

  &__version{
    p {
      padding-left: 1.75rem; color: black;
    }

    span {
      color: $primary;
    }
  }

  #toolbar-container {
    width: 90%;
    margin: 0 auto rem(15) auto;
    background-color: $light;
  }
  &__editor{
    width: 90%;
  }
  #editor {
    width: 100%;
    height: 100%;
    margin: 0 auto rem(15) auto;
    background-color: $light;

    .tox-tinymce{
      height: 100% !important;
    }
  }
}
</style>
